<template>
    <div>
        <!--内容部分 start-->
        <div>
            <!--蓝色背景 start-->
            <div class="blue_bar">
                <!--标题 start-->
                <div class="blue_title">收入总额(元)</div>
                <!--收入金额 start-->
                <div class="income">{{come.agentSummery.salesman}}</div>
                <!--商户类别 start-->
                <div class="merchant_type">
                    <van-tag color="#00aaee" text-color="white" class="label">特约代理</van-tag>
                </div>
                <!--微信及支付宝收入 start-->
                <div class="income_type">

                    <van-row gutter="10">
<!--                        <van-col span="8">-->
<!--                            <div >-->
<!--                                微信(今)-->
<!--                                <div class="kind">{{come.alipay_summary}}</div>-->
<!--                            </div>-->

<!--                        </van-col>-->
                        <van-col span="12">
                            <div  @click="merchant_info">
                                商户总数
                                <div class="kind">{{come.merchantNum}}</div>
                            </div>

                        </van-col>
                        <van-col span="12">
                            <div @click="salesman_info" >
                                业务员总数
                                <div class="kind">{{come.salesmanNum}}</div>
                            </div>
                        </van-col>
                    </van-row>
                </div>
            </div>
            <!--蓝色背景 end-->
            <!--菜单 start-->
            <div style="margin-top: 0.3rem">
                <van-grid :column-num="3" icon-size="1rem">
                    <van-grid-item :to="menu_item.menu_url" v-for="(menu_item,key) in menu_data" :key="key"
                                   :icon="menu_item.menu_img" :text="menu_item.menu_text"/>
                </van-grid>
            </div>
            <!--菜单 end-->
        </div>
        <!--内容部分 end-->
    </div>
</template>

<script>
    // 菜单图片
    import merchant_information from '../../assets/images/merchant_information.png'; //商户信息
    import merchant_information_6 from '../../assets/images/6.png'; //商户信息
    import AgentMerchantFlow from '../../assets/images/transaction_flow.png'; //交易流水
    import AgentMerchantFlow_num from '../../assets/images/3.png'; //交易汇总
    import MerchantStoreSummary from '../../assets/images/express_collection.png'; //交易汇总
    import collection_code from '../../assets/images/4.png'; //代理管理
    import express_collection from '../../assets/images/1.png'; //业务员管理
    import express_collection_2 from '../../assets/images/2.png'; //快捷收款
    import express_collection_5 from '../../assets/images/5.png'; //快捷收款
    export default {
        name: "AgentHomepage", //代理首页
        data() {
            return {
                // 收入金额
                come:"",
                menu_data: [
                    {
                        'menu_text': "代理信息",
                        'menu_img': merchant_information,
                        'menu_url': "/AgentInfomation"
                    },
                    {
                        'menu_text': "我的账户",
                        'menu_img': merchant_information_6,
                        'menu_url': "/MyAccount"
                    },
                    {
                        'menu_text': "数据分析",
                        'menu_img': express_collection_5,
                        'menu_url': "/AgentAnalysis"
                    },

                    {
                        'menu_text': "代理管理",
                        'menu_img': collection_code,
                        'menu_url': "/AgentManagement"
                    },

                    {
                            'menu_text': "业务员管理",
                            'menu_img': express_collection,
                            'menu_url': '/SalesmanManagement'
                    },

                       {
                            'menu_text': "商户管理",
                            'menu_img': express_collection_2,
                            'menu_url': "/MerchantManagement"
                        },
                      {
                          'menu_text': "交易汇总",
                            'menu_img': AgentMerchantFlow_num,
                            'menu_url': "/AgentMerchantCollect"
                        },
                    {
                        'menu_text': "交易流水",
                        'menu_img': AgentMerchantFlow,
                        'menu_url': "/AgentMerchantFlow"
                    },


                    {
                        'menu_text': "交易日报",
                        'menu_img': MerchantStoreSummary,
                        'menu_url': "/MerchantStoreSummary"
                    },


                ],

                // {
                //     'menu_text': "",
                //     'menu_img': "",
                //     'menu_url': ""
                // },
                //  {



            };
        },
        // 组件内路由--进入组件时
        beforeRouteEnter(to, from, next) {
            window.document.body.style.backgroundColor = '#f5f5f5';
            next();
        },
        // 组件内路由--离开组件时
        beforeRouteLeave(to, from, next) {
            window.document.body.style.backgroundColor = '';
            next();
        },
        methods: {
            //收入金额
            income(){
                this.$http.get('/wechat/api.agent.index/info').then(response => {
                    // console.log(response.data);
                    this.come=response.data.msg
                })
            },
            merchant_info(){
                this.$router.push('/MerchantManagement')
            },
            salesman_info(){
                this.$router.push('/SalesmanManagement')
            }
        },
        mounted(){
            // 收入金额
            this.income()
        },
    }
</script>

<style scoped>
    /*蓝色背景*/
    .blue_bar {
        background-color: #00aaee;
        width: 100%;
        color: white;
        text-align: center;
        padding: 0.3rem 0;
    }

    /*标题*/
    .blue_title {
        color: #DEF0FD;
        line-height: 40px;
        font-size: 14px;
    }

    /*收入金额*/
    .income {
        line-height: 40px;
        font-size: 45px;
    }

    /*商户类别整体*/
    .merchant_type {
        padding: 14px 0;
    }

    /*商户类别*/
    .label {
        border: 1px solid #fff;
        border-radius: 5px;
        padding: 3px 10px;
        font-size: 16px;
    }

    /*收入类别*/
    .income_type {
        padding: 14px 0;
        font-size: 16px;
    }
    .kind{
        position: relative;
        top: 0.1rem;
        font-size: 0.5rem;
    }
</style>
